import { action, observable } from "mobx";

export default class CodeDataSource {
  @observable
  private _codeDataMap!: { [KEY: string]: CodeData[]; };

  private _codeDataInfoMap: {
    [key: string]: {
      [code: string]: CodeData;
    };
  };

  public constructor() {
    this._codeDataInfoMap = {};
  }

  @action
  public append(_codeDataMap?: { [KEY: string]: CodeData[] }): void {
    if (_codeDataMap == null) {
      return;
    }

    this._codeDataMap = { ...this._codeDataMap, ..._codeDataMap };

    for (const key in _codeDataMap) {
      const codeDataInfo = (this._codeDataInfoMap[key] = {});

      _codeDataMap[key].forEach((codeData: CodeData) => {
        codeDataInfo[codeData.code] = codeData;
      });
    }
  }

  public exists(key: string): boolean {
    return this._codeDataMap != null && this._codeDataMap[key] != null;
  }

  public get(key: string): CodeData[] {
    if (!this.exists(key)) {
      return [] as CodeData[];
    }

    return this._codeDataMap[key];
  }

  public getCodeData(key: string, code: string | boolean): CodeData {
    if (!this._codeDataMap || !this._codeDataMap[key]) {
      return {} as CodeData;
    }

    if (this._codeDataInfoMap[key] == null || this._codeDataInfoMap[key][code + ""] == null) {
      return {} as CodeData;
    }

    return this._codeDataInfoMap[key][code + ""];
  }

  public getCodeName(key: string, code?: string | boolean) {
    if (key == null || code == null) {
      return;
    }

    const codeData = this.getCodeData(key, code);

    if (codeData) {
      return codeData.name || code;
    }
  }
}

export interface CodeData {
  code: any;
  name: any;
  [KEY: string]: any;
}
